import request from '@/utils/request'
export function getJobInfo(id){
  return request({
    url: `api/app/job/${id}`
  })
}

export function updateJob(data,id){
  delete data.classId
  return request({
    url: `api/app/job/${id}`,
    method: 'PUT',
    data,
    json: true
  })
}

// 获取任务信息
export function info(classid,booksubid) {
  return request({
    url: `api/app/job/studentByClassIdandBookSubId`,
    data:{
      classid,
      booksubid
    }
  })
}

export function save(data,id){
  return request({
    url: 'api/app/job/saveJob',
    data,
    method: 'POST',
    json: true
  })
}

export function saveTime(data){
  return request({
    url: 'api/app/classRecord',
    data,
    method: 'POST',
    json: true
  })
}


// WEBPACK FOOTER //
// ./src/api/job.js